export * from './FiltroScore'